import React from 'react';
import { Grid } from '@mui/material';
import StatCard from '../common/StatCard';
import PeopleOutlinedIcon from '@mui/icons-material/PeopleOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import MonetizationOnOutlinedIcon from '@mui/icons-material/MonetizationOnOutlined';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';

const formatCurrency = (amount) => {
  if (!amount) return '0';
  if (amount >= 10000000) return `${(amount / 10000000).toFixed(1)} Cr`;
  if (amount >= 100000) return `${(amount / 100000).toFixed(1)} L`;
  if (amount >= 1000) return `${(amount / 1000).toFixed(1)} K`;
  return amount.toLocaleString('en-IN');
};

const DashboardStats = ({ stats }) => {
  const {
    totalLeads = 0,
    documentsPending = 0,
    withBanker = 0,
    approved = 0,
    disbursed = 0,
    rejected = 0,
    totalLoanAmount = 0,
    disbursedAmount = 0,
  } = stats || {};

  const statCards = [
    { title: 'Total Leads', value: totalLeads, icon: <PeopleOutlinedIcon />, color: '#1A73E8' },
    { title: 'Docs Pending', value: documentsPending, icon: <DescriptionOutlinedIcon />, color: '#F9AB00' },
    { title: 'With Banker', value: withBanker, icon: <AccountBalanceOutlinedIcon />, color: '#A142F4' },
    { title: 'Approved', value: approved, icon: <CheckCircleOutlinedIcon />, color: '#1E8E3E' },
    { title: 'Disbursed Amt', value: `₹${formatCurrency(disbursedAmount)}`, icon: <MonetizationOnOutlinedIcon />, color: '#1A73E8' },
    { title: 'Rejected', value: rejected, icon: <CancelOutlinedIcon />, color: '#D93025' },
  ];

  return (
    <Grid container spacing={2.5}>
      {statCards.map((card) => (
        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 2 }} key={card.title}>
          <StatCard
            title={card.title}
            value={card.value}
            icon={card.icon}
            color={card.color}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default DashboardStats;
